 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTTITLEPAGE from '@/components/Text/titlepage'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLEPAGE2 from '@/components/Text/TitlePage2'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTALSOBY1 from '@/components/Text/AlsoBy1'
 import TEXTACKNOWLEDGMENTS from '@/components/Text/Acknowledgments'
 import TEXTDEDICATION from '@/components/Text/Dedication'
 import TEXTCASTOFCHARACTERS from '@/components/Text/CastOfCharacters'
 import TEXTQUOTE from '@/components/Text/Quote'
 import TEXTTOC from '@/components/Text/TOC'
 import TEXTPROLOGUE from '@/components/Text/Prologue'
 import TEXTCHAPTER_001 from '@/components/Text/Chapter_001'
 import TEXTCHAPTER_002 from '@/components/Text/Chapter_002'
 import TEXTCHAPTER_003 from '@/components/Text/Chapter_003'
 import TEXTCHAPTER_004 from '@/components/Text/Chapter_004'
 import TEXTCHAPTER_005 from '@/components/Text/Chapter_005'
 import TEXTCHAPTER_006 from '@/components/Text/Chapter_006'
 import TEXTCHAPTER_007 from '@/components/Text/Chapter_007'
 import TEXTCHAPTER_008 from '@/components/Text/Chapter_008'
 import TEXTCHAPTER_009 from '@/components/Text/Chapter_009'
 import TEXTCHAPTER_010 from '@/components/Text/Chapter_010'
 import TEXTCHAPTER_011 from '@/components/Text/Chapter_011'
 import TEXTCHAPTER_012 from '@/components/Text/Chapter_012'
 import TEXTCHAPTER_013 from '@/components/Text/Chapter_013'
 import TEXTCHAPTER_014 from '@/components/Text/Chapter_014'
 import TEXTCHAPTER_015 from '@/components/Text/Chapter_015'
 import TEXTCHAPTER_016 from '@/components/Text/Chapter_016'
 import TEXTCHAPTER_017 from '@/components/Text/Chapter_017'
 import TEXTCHAPTER_018 from '@/components/Text/Chapter_018'
 import TEXTCHAPTER_019 from '@/components/Text/Chapter_019'
 import TEXTCHAPTER_020 from '@/components/Text/Chapter_020'
 import TEXTCHAPTER_021 from '@/components/Text/Chapter_021'
 import TEXTCHAPTER_022 from '@/components/Text/Chapter_022'
 import TEXTCHAPTER_023 from '@/components/Text/Chapter_023'
 import TEXTCHAPTER_024 from '@/components/Text/Chapter_024'
 import TEXTCHAPTER_025 from '@/components/Text/Chapter_025'
 import TEXTCHAPTER_026 from '@/components/Text/Chapter_026'
 import TEXTCHAPTER_027 from '@/components/Text/Chapter_027'
 import TEXTCHAPTER_028 from '@/components/Text/Chapter_028'
 import TEXTCHAPTER_029 from '@/components/Text/Chapter_029'
 import TEXTCHAPTER_030 from '@/components/Text/Chapter_030'
 import TEXTCHAPTER_031 from '@/components/Text/Chapter_031'
 import TEXTCHAPTER_032 from '@/components/Text/Chapter_032'
 import TEXTCHAPTER_033 from '@/components/Text/Chapter_033'
 import TEXTCHAPTER_034 from '@/components/Text/Chapter_034'
 import TEXTCHAPTER_035 from '@/components/Text/Chapter_035'
 import TEXTCHAPTER_036 from '@/components/Text/Chapter_036'
 import TEXTCHAPTER_037 from '@/components/Text/Chapter_037'
 import LOVE_2 from '@/components/love_2'
 import TEXTEPILOGUE from '@/components/Text/Epilogue'
 import TEXTABOUTTHEAUTHOR from '@/components/Text/AboutTheAuthor'
 import TEXTCTA from '@/components/Text/CTA'
 import TEXTWILLIAMFLORENCEOTHERBOOKS_V1 from '@/components/Text/WILLIAMFLORENCEotherbooks_v1'
 import TEXTRAVENSRIDGE_AMAZON from '@/components/Text/RAVENSRIDGE_AMAZON'
 import TEXTMYSTERYADPAGEAPRIL2018 from '@/components/Text/Mystery-AdPage-April2018'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/titlepage",
 			"name" : "Text/titlepage",
 			"component" : TEXTTITLEPAGE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Text/TitlePage2",
 			"name" : "Text/TitlePage2",
 			"component" : TEXTTITLEPAGE2
 		},
 		{
 			"path" : "/Text/copyright",
 			"name" : "Text/copyright",
 			"component" : TEXTCOPYRIGHT
 		},
 		{
 			"path" : "/Text/AlsoBy1",
 			"name" : "Text/AlsoBy1",
 			"component" : TEXTALSOBY1
 		},
 		{
 			"path" : "/Text/Acknowledgments",
 			"name" : "Text/Acknowledgments",
 			"component" : TEXTACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/Text/Dedication",
 			"name" : "Text/Dedication",
 			"component" : TEXTDEDICATION
 		},
 		{
 			"path" : "/Text/CastOfCharacters",
 			"name" : "Text/CastOfCharacters",
 			"component" : TEXTCASTOFCHARACTERS
 		},
 		{
 			"path" : "/Text/Quote",
 			"name" : "Text/Quote",
 			"component" : TEXTQUOTE
 		},
 		{
 			"path" : "/Text/TOC",
 			"name" : "Text/TOC",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/Prologue",
 			"name" : "Text/Prologue",
 			"component" : TEXTPROLOGUE
 		},
 		{
 			"path" : "/Text/Chapter_001",
 			"name" : "Text/Chapter_001",
 			"component" : TEXTCHAPTER_001
 		},
 		{
 			"path" : "/Text/Chapter_002",
 			"name" : "Text/Chapter_002",
 			"component" : TEXTCHAPTER_002
 		},
 		{
 			"path" : "/Text/Chapter_003",
 			"name" : "Text/Chapter_003",
 			"component" : TEXTCHAPTER_003
 		},
 		{
 			"path" : "/Text/Chapter_004",
 			"name" : "Text/Chapter_004",
 			"component" : TEXTCHAPTER_004
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js